import React from "react";
import { useLocation } from "react-router-dom";
import Catalogue from "./Catalogue";
import { getLocalisedAcademyMedia } from "../../api/academy";

const AcademyCatalogue: React.FC = () => {
  const filter = useLocation().search.replace("?f=", "");

  return (
    <Catalogue
      getPaginatedMedia={getLocalisedAcademyMedia}
      section_type="academy"
      filterKey={filter}
    />
  );
};

export default AcademyCatalogue;
